import { useState } from 'react'
import PriceChart from './components/PriceChart'
import PriceInsights from './components/PriceInsights'
import CSVUpload from './components/CSVUpload'
import ConsumptionChart from './components/ConsumptionChart'
import Statistics from './components/Statistics'
import TypicalDayProfile from './components/TypicalDayProfile'
import ImbalanceChart from './components/ImbalanceChart'
import './App.css'

function App() {
  const [includeVAT, setIncludeVAT] = useState(true)
  const [prices, setPrices] = useState([])
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [insights, setInsights] = useState(null)
  const [consumptionData, setConsumptionData] = useState(null)

  const handleDataLoaded = (data) => {
    setConsumptionData(data)
  }

  const handlePricesLoaded = (loadedPrices, date) => {
    setPrices(loadedPrices)
    setSelectedDate(date)
  }

  const handleInsightsCalculated = (newInsights) => {
    setInsights(newInsights)
  }

  return (
    <div className="app">
      <header className="app-header">
        <div className="title-area">
          <h1>Mano Elektra</h1>
          <p>Nord Pool kainų analizė ir suvartojimo optimizavimas</p>
        </div>
      </header>

      <main className="app-main">
        <div className="settings-bar">
          <div className="vat-control-large">
            <span className="vat-text">Rodyti kainas su PVM (21%)</span>
            <label className="large-switch">
              <input 
                type="checkbox" 
                checked={includeVAT} 
                onChange={() => setIncludeVAT(!includeVAT)} 
              />
              <span className="large-slider"></span>
            </label>
          </div>
        </div>

        <section className="section">
          <h2>📊 Nord Pool Kainos (LT)</h2>
          <PriceChart 
            includeVAT={includeVAT} 
            onPricesLoaded={handlePricesLoaded}
            insights={insights}
          />
          {prices.length > 0 && (
            <PriceInsights 
              selectedDate={selectedDate} 
              currentPrices={prices} 
              includeVAT={includeVAT}
              onInsightsCalculated={handleInsightsCalculated}
            />
          )}
        </section>

        <section className="section">
          <h2>📤 Suvartojimo Analizė</h2>
          <div className="section-instruction">
            💡 <strong>Instrukcija:</strong> Savo 15 min. suvartojimo duomenis galite atsisiųsti iš <a href="https://mano.eso.lt/" target="_blank" rel="noopener noreferrer">mano.eso.lt</a> savitarnos.
          </div>
          <CSVUpload onDataLoaded={handleDataLoaded} />
        </section>

        {consumptionData && (
          <>
            <section className="section">
              <h2>💰 Statistika</h2>
              <Statistics 
                statistics={consumptionData.statistics} 
                includeVAT={includeVAT} 
              />
            </section>

            <section className="section">
              <h2>⚡ Valandinis Suvartojimas</h2>
              <ConsumptionChart 
                consumption={consumptionData.consumption}
                priceData={consumptionData.prices}
                includeVAT={includeVAT} 
              />
            </section>

            <section className="section">
              <TypicalDayProfile 
                consumptionData={consumptionData.consumption}
              />
            </section>

            <section className="section">
              <ImbalanceChart 
                consumptionData={consumptionData.consumption}
              />
            </section>
          </>
        )}
      </main>

      <footer className="app-footer">
        <p>© {new Date().getFullYear()} Mano Elektra | Duomenys iš Nord Pool & ESO</p>
      </footer>
    </div>
  )
}

export default App
